import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const SmlouvaProtokol = lazy(() =>
  import('@/modules/vozidla/SmlouvaProtokol').then((m) => ({ default: m.SmlouvaProtokol })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/vozidla/smlouvy/$id/protokol/leasing',
  component: () => (
    <Suspense fallback={null}>
      <SmlouvaProtokol leasing />
    </Suspense>
  ),
});
